<section class="ui-data-surface tw:flex tw:flex-col tw:gap-app-4 tw:min-w-0"
  [class.ui-data-surface--flush]="flush()">
  <ng-content></ng-content>
</section>
